/**
 * Generated by orval v7.9.0 🍺
 * Do not edit manually.
 * Meeting BaaS API
 * API for managing meeting bots, calendar integrations, and webhooks
 * OpenAPI spec version: 2.0.0
 */

/**
 * The current state of the meet login.

- `active`: Login is healthy and can be assigned to bots
- `invalid`: System auto-flipped this on bot login failure (suspended user, first-time interactive login required, etc.). Manual re-enable required.
 */
export type CreateMeetLogin201DataState =
  (typeof CreateMeetLogin201DataState)[keyof typeof CreateMeetLogin201DataState]

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CreateMeetLogin201DataState = {
  active: "active",
  invalid: "invalid"
} as const
